import React, { Component } from "react";

class CadastroObservacao extends Component {
  render() {
    return (
      <div className="row">
        <div className="col-12 grid-margin">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">OBSERVAÇÕES</h4>
              <div className="form-group row">
                <div className="col-md-12">
                  <textarea
                    rows="8"
                    placeholder="OBSERVAÇÕES"
                    name="observacoes"
                    className="form-control"
                    value={this.props.observacoes}
                    onChange={this.props.onChange}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 text-right">
                  <button type="submit" className="btn btn-success mb-2">
                    Concluido
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CadastroObservacao;
